import { convertToMinutesAndSeconds } from '@/utils';
import { Grid, LinearProgress, Typography } from '@mui/material';

interface Props {
  value: number;
  maxTimeSecRecord: any;
}

function ProgressTimer({ value, maxTimeSecRecord }: Props) {
  return (
    <Grid container sx={{ marginLeft: '16px' }}>
      <Grid item>
        <LinearProgress
          aria-describedby="test"
          sx={{
            height: '40px',
            width: '66px',
            borderRadius: '88px',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
          }}
          variant="determinate"
          value={(value / maxTimeSecRecord) * 100}
        />
        <Typography
          style={{
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '0px',
            color: 'white',
            textAlign: 'center',
            position: 'absolute',
            top: '50%',
            transform: 'translate(19%,-50%)',
          }}
        >
          {value === 0
            ? convertToMinutesAndSeconds(maxTimeSecRecord)
            : convertToMinutesAndSeconds(maxTimeSecRecord)}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default ProgressTimer;
